'use client'

import { LinkReadyCard } from '../LinkReadyCard'
import { SendMock } from '../feature-mocks/SendMock'
import { useSendJourney } from './SendJourneyContext'
import { DOCK_PHASE } from './constants'

/**
 * FeatureZigzag "Sending" anchor for the send journey. Renders SendMock in
 * place when the journey is inactive; when active it becomes an invisible
 * size ghost that reserves the row's layout and gives the provider the dock
 * rect the floating SendMock lands on. On arrival the hero's link-ready card
 * reveals below the docked mock to close the story.
 */
export function DockSendSlot() {
  const journey = useSendJourney()
  const enabled = journey?.enabled ?? false
  const docked = journey?.docked ?? false
  return (
    <div ref={journey?.dockSlotRef} style={{ position: 'relative' }}>
      <div aria-hidden={enabled || undefined} style={{ visibility: enabled ? 'hidden' : 'visible' }}>
        <SendMock phase={enabled ? DOCK_PHASE : undefined} />
      </div>
      {enabled && docked && (
        <div
          className="st-journey-link-reveal"
          style={{ position: 'absolute', left: -18, right: '34%', bottom: -58, zIndex: 31 }}>
          <LinkReadyCard />
        </div>
      )}
    </div>
  )
}
